module.exports = __webpack_public_path__ + "a37e3aaf29aa9328f9cb61c5da9570b1.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/alert_microphone.png
// module id = 16
// module chunks = 0